<template>
  <div
    class="ag-indicador"
    :data-active="active"
    :data-loading="loading"
    :data-disabled="disabled"
    :data-unavailable="unavailable"
    @click="onClick"
  >
    <v-skeleton-loader v-if="loading" type="heading, paragraph" />

    <template v-else>
      <div class="ag-indicador__header">
        <div class="ag-indicador__title">
          <slot name="title">
            {{ title }}
          </slot>
        </div>

        <div v-if="$slots['append-title']" class="ag-indicador__append-title">
          <slot name="append-title" />
        </div>
      </div>

      <div class="ag-indicador__value">
        <template v-if="unavailable"> - </template>

        <slot v-else name="value">
          {{ value }}
        </slot>
      </div>

      <div class="ag-indicador__footer">
        <div class="ag-indicador__caption">
          <template v-if="unavailable"> Dados indisponíveis </template>

          <slot v-else name="caption">
            {{ caption }}
          </slot>
        </div>

        <div v-if="$slots['append-caption']" class="ag-indicador__append-caption">
          <slot name="append-caption" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import AGCard from '@/components/common/AGCard.vue';
import AGGraficoRosca from '@/components/common/AGGraficoRosca.vue';
import AGIcon from '@/components/common/AGIcon.vue';
import AgTooltipOld from '@/components/common/AGTooltipOld.vue';

export default {
  emits: ['click'],

  components: {
    AGGraficoRosca,
    AGCard,
    AGIcon,
    AGTooltip: AgTooltipOld,
  },

  props: {
    title: {
      type: [String, Number, null],
      default: undefined,
    },

    value: {
      type: [String, Number, null],
      default: undefined,
    },

    caption: {
      type: [String, Number, null],
      default: undefined,
    },

    active: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    unavailable: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onClick() {
      if (this.disabled || this.loading || this.active) return;

      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
.ag-indicador {
  width: 100%;
  height: 100%;

  position: relative;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 16px;

  padding: 16px;

  border: 1px solid $neutral-color-low-dark;
  border-radius: 4px;

  background-color: $neutral-color-low-medium;
  transition: 100ms;

  &__header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  &__footer {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
  }

  &__title {
    font-size: 20px;
    font-weight: 400;
    color: $brand-color-primary-medium;
  }

  &__value {
    font-size: 40px;
    font-weight: 400;
    color: $neutral-color-high-medium;
  }

  &__caption {
    font-size: 16px;
    font-weight: 400;
    color: $neutral-color-high-medium;
  }

  &:hover:not([data-disabled='true']):not([data-loading='true']):not([data-unavailable='true']) {
    background-color: $brand-color-highlight-light;
    cursor: pointer;
  }

  &[data-active='true']:not([data-disabled='true']):not([data-loading='true']):not([data-unavailable='true']) {
    background-color: $neutral-color-low-light;

    &:after {
      content: '';

      width: 100%;
      height: 2px;

      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      border-top: 4px solid $brand-color-highlight-medium;
    }
  }

  &[data-loading='true'] {
    background-color: $neutral-color-low-light;
  }

  &[data-disabled='true']:not([data-loading='true']) {
    background-color: $neutral-color-low-dark;

    &:after {
      display: none;
    }
  }
}
</style>
